import styled from 'styled-components';

export const PageHeaderWrapper = styled.div`
  h1 {
    font-size: 28px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 4px;
    letter-spacing: -0.02em;
  }

  p {
    font-size: 12px;
    color: #6b7280;
    margin: 0;
  }
`;
